import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Proteins from "@/pages/Proteins";
import Menus from "@/pages/Menus";
import Purchases from "@/pages/Purchases";
import Users from "@/pages/Users";
import Platform from "@/pages/Platform";
import { isPlatformOwner } from "@/lib/perms";

function Protected({ children, perm }) {
  const { user, loading, can } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (perm && !can(perm)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function PlatformOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isPlatformOwner(user)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Carregando…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/empresas" element={<Protected perm="companies:read"><Companies /></Protected>} />
          <Route path="/proteinas" element={<Protected perm="proteins:read"><Proteins /></Protected>} />
          <Route path="/cardapios" element={<Protected perm="menus:read"><Menus /></Protected>} />
          <Route path="/compras" element={<Protected perm="purchase:read"><Purchases /></Protected>} />
          <Route path="/usuarios" element={<Protected perm="users:read"><Users /></Protected>} />
          <Route path="/plataforma" element={<PlatformOnly><Platform /></PlatformOnly>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
